<template>
    <div class="x-map-view">
        <!-- 地图 -->
        <baidu-map ref="vueMap" class="x-map" :center="mapCenter" :zoom="mapZoom" :scroll-wheel-zoom="true" :double-click-zoom="false" :map-click="false" @ready="handler" @moving="syncCenterAndZoom" @zoomend="syncCenterAndZoom">
            <slot></slot>
        </baidu-map>
    </div>
</template>

<script>
export default {
  name: 'MyMap',
  props: {
    center: {
      type: [Object, String],
      default: () => {
        return {
          lat: 39.915,
          lng: 116.504
        };
      }
    },
    zoom: {
      type: Number,
      default: 19,
    }
  },
    
  data() {
    return {
      mapCenter: this.center, // 中心点坐标
      mapZoom: this.zoom, // 地图缩放级别
    };
  },
  methods: {

    /**
         * 地图组件渲染完毕触发
         * @param {Object} BMap  BMap核心类
         */
    handler({ BMap, map }) {
      let geoc = new BMap.Geolocation();
      geoc.getCurrentPosition(res => {
        if (geoc.getStatus() == BMAP_STATUS_SUCCESS) {
          this.mapCenter = res.point;
        }
      });
      this.$emit('ready', BMap, map);
    },
        
    /**
         * 拖动地图\缩放地图触发
         * @param {Object} e 事件对象
         */
    syncCenterAndZoom(e) {
      this.mapCenter = e.target.getCenter();
      this.mapZoom = e.target.getZoom();
      this.$emit('movingAndZoom');
    },
  },

  watch: {
    center: {
      handler(val) {                
        this.mapCenter = val;
      },
      deep: true
    }
  },
};
</script>

<style lang="scss" scoped>

</style>